import Flathouselg from "./flathouse.webp";
import Cozmohouselg from "./cozmohouse.webp";
import Breezyhouselg from "./breezylogo.webp";

const myzalogo = [Flathouselg, Cozmohouselg, Breezyhouselg];

export default myzalogo;
